import React from 'react';
import Section from '../layouts/Section';
import PageLayout from '../layouts/PageLayout';
import { Link } from 'react-router-dom';

const TermsConditions = () => {
  return (
    <PageLayout title="Cell Station – Terms & Conditions">
      <Section title="Terms & Conditions">
        <div className="section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="policy-content" style={styles.content}>

                  {/* Header Section */}
                  <div style={styles.headerSection}>
                    <div style={styles.headerIcon}>
                      <i className="fas fa-file-contract"></i>
                    </div>
                    <div>
                      <h2 style={styles.headerTitle}>Terms and Conditions of Service</h2>
                      <p style={styles.headerSubtitle}>
                        Please read these terms carefully before using our services
                      </p>
                    </div>
                  </div>

                  <div style={styles.metaInfo}>
                    <div style={styles.metaItem}>
                      <i className="fas fa-calendar-alt" style={styles.metaIcon}></i>
                      <span><strong>Effective Date:</strong> January 1, 2025</span>
                    </div>
                    <div style={styles.metaItem}>
                      <i className="fas fa-sync-alt" style={styles.metaIcon}></i>
                      <span><strong>Last Updated:</strong> January 2025</span>
                    </div>
                  </div>

                  {/* Introduction */}
                  <div style={styles.introBox}>
                    <p style={styles.introParagraph}>
                      Welcome to Cell Station ("Company," "we," "our," or "us"). These Terms and Conditions
                      ("Terms") govern your use of our repair services, retail products, website, and any
                      related services provided by Cell Station located at 2500 W Moreland Rd, Space #1077,
                      Willow Grove, PA 19090. By engaging our services or making purchases, you ("Customer,"
                      "you," or "your") acknowledge that you have read, understood, and agree to be bound by
                      these Terms.
                    </p>
                  </div>

                  {/* Table of Contents */}
                  <div style={styles.tocSection}>
                    <h3 style={styles.tocTitle}>
                      <i className="fas fa-list" style={{ marginRight: '10px' }}></i>
                      Table of Contents
                    </h3>
                    <div style={styles.tocGrid}>
                      <div style={styles.tocColumn}>
                        <a href="#section1" style={styles.tocLink}>1. Acceptance of Terms</a>
                        <a href="#section2" style={styles.tocLink}>2. Services Description</a>
                        <a href="#section3" style={styles.tocLink}>3. Repair Service Agreement</a>
                        <a href="#section4" style={styles.tocLink}>4. Device Check-In Policy</a>
                        <a href="#section5" style={styles.tocLink}>5. Pricing & Payment</a>
                        <a href="#section6" style={styles.tocLink}>6. Warranty Terms</a>
                        <a href="#section7" style={styles.tocLink}>7. Parts & Components</a>
                      </div>
                      <div style={styles.tocColumn}>
                        <a href="#section8" style={styles.tocLink}>8. Data & Privacy</a>
                        <a href="#section9" style={styles.tocLink}>9. Limitation of Liability</a>
                        <a href="#section10" style={styles.tocLink}>10. Retail Sales Terms</a>
                        <a href="#section11" style={styles.tocLink}>11. Customer Conduct</a>
                        <a href="#section12" style={styles.tocLink}>12. Dispute Resolution</a>
                        <a href="#section13" style={styles.tocLink}>13. General Provisions</a>
                        <a href="#section14" style={styles.tocLink}>14. Contact Information</a>
                      </div>
                    </div>
                  </div>

                  {/* Section 1 */}
                  <div id="section1" style={styles.section}>
                    <div style={styles.sectionHeader}>
                      <span style={styles.sectionNumber}>1</span>
                      <h3 style={styles.heading}>Acceptance of Terms</h3>
                    </div>
                    <p style={styles.paragraph}>
                      By accessing our store, using our website, or utilizing any of our services, you
                      confirm that you are at least 18 years of age (or have parental/guardian consent)
                      and have the legal capacity to enter into binding agreements. If you are accepting
                      these Terms on behalf of a company or other legal entity, you represent that you
                      have the authority to bind such entity to these Terms.
                    </p>
                    <div style={styles.highlightBox}>
                      <i className="fas fa-exclamation-circle" style={styles.highlightIcon}></i>
                      <p style={styles.highlightText}>
                        <strong>Important:</strong> If you do not agree to these Terms, please do not use
                        our services. Your continued use constitutes acceptance of these Terms and any
                        future modifications.
                      </p>
                    </div>
                  </div>

                  {/* Section 2 */}
                  <div id="section2" style={styles.section}>
                    <div style={styles.sectionHeader}>
                      <span style={styles.sectionNumber}>2</span>
                      <h3 style={styles.heading}>Services Description</h3>
                    </div>
                    <p style={styles.paragraph}>
                      Cell Station is a professional electronics repair and retail establishment specializing
                      in mobile device services. Our comprehensive offerings include:
                    </p>

                    <div style={styles.servicesGrid}>
                      <div style={styles.serviceCard}>
                        <div style={styles.serviceIcon}>
                          <i className="fas fa-tools"></i>
                        </div>
                        <h4 style={styles.serviceTitle}>Repair Services</h4>
                        <ul style={styles.serviceList}>
                          <li>Screen replacement & LCD repair</li>
                          <li>Battery replacement</li>
                          <li>Charging port repair</li>
                          <li>Camera repair & replacement</li>
                          <li>Speaker & microphone repair</li>
                          <li>Water damage treatment</li>
                          <li>Software troubleshooting</li>
                          <li>Data recovery services</li>
                        </ul>
                      </div>
                      <div style={styles.serviceCard}>
                        <div style={styles.serviceIcon}>
                          <i className="fas fa-mobile-alt"></i>
                        </div>
                        <h4 style={styles.serviceTitle}>Devices We Service</h4>
                        <ul style={styles.serviceList}>
                          <li>Apple iPhone (all models)</li>
                          <li>Samsung Galaxy devices</li>
                          <li>Google Pixel phones</li>
                          <li>iPad & Android tablets</li>
                          <li>MacBooks & laptops</li>
                          <li>Smartwatches</li>
                          <li>Gaming consoles</li>
                          <li>Other mobile devices</li>
                        </ul>
                      </div>
                      <div style={styles.serviceCard}>
                        <div style={styles.serviceIcon}>
                          <i className="fas fa-shopping-bag"></i>
                        </div>
                        <h4 style={styles.serviceTitle}>Retail Products</h4>
                        <ul style={styles.serviceList}>
                          <li>Phone cases & covers</li>
                          <li>Screen protectors</li>
                          <li>Charging cables & adapters</li>
                          <li>Wireless chargers</li>
                          <li>Earbuds & headphones</li>
                          <li>Power banks</li>
                          <li>Car mounts & accessories</li>
                          <li>Other mobile accessories</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* Section 3 */}
                  <div id="section3" style={styles.section}>
                    <div style={styles.sectionHeader}>
                      <span style={styles.sectionNumber}>3</span>
                      <h3 style={styles.heading}>Repair Service Agreement</h3>
                    </div>

                    <h4 style={styles.subheading}>3.1 Diagnosis & Estimates</h4>
                    <p style={styles.paragraph}>
                      Cell Station provides complimentary initial diagnostics for most devices. Upon
                      examination, we will provide you with a detailed estimate including the nature of
                      the problem, recommended repairs, parts required, and total cost. You must provide
                      written or verbal authorization before we proceed with any repair work. Estimates
                      are valid for 7 days from the date of diagnosis.
                    </p>

                    <h4 style={styles.subheading}>3.2 Authorization & Consent</h4>
                    <p style={styles.paragraph}>
                      By signing our service agreement or verbally authorizing repairs, you acknowledge that:
                    </p>
                    <ul style={styles.list}>
                      <li>You are the legal owner of the device or have authorization to request repairs</li>
                      <li>You authorize Cell Station to perform the agreed-upon repairs</li>
                      <li>You understand the associated costs and agree to pay upon completion</li>
                      <li>You have been informed of potential risks associated with the repair</li>
                      <li>You consent to our technicians accessing your device as necessary for repair</li>
                    </ul>

                    <h4 style={styles.subheading}>3.3 Repair Timeframes</h4>
                    <p style={styles.paragraph}>
                      Most repairs are completed same-day or within 24-48 hours, depending on complexity
                      and parts availability. We will notify you immediately when your device is ready.
                      Complex repairs or those requiring special-order parts may take longer, and you will
                      be informed of expected completion times.
                    </p>

                    <h4 style={styles.subheading}>3.4 Additional Issues Discovered</h4>
                    <p style={styles.paragraph}>
                      If additional issues are discovered during repair that were not part of the original
                      estimate, we will contact you before proceeding with any additional work. You have
                      the right to decline additional repairs; however, this may affect the functionality
                      of the original repair or void warranty coverage if issues are related.
                    </p>
                  </div>

                  {/* Section 4 */}
                  <div id="section4" style={styles.section}>
                    <div style={styles.sectionHeader}>
                      <span style={styles.sectionNumber}>4</span>
                      <h3 style={styles.heading}>Device Check-In Policy</h3>
                    </div>

                    <div style={styles.policyGrid}>
                      <div style={styles.policyCard}>
                        <div style={{...styles.policyIcon, backgroundColor: '#28a745'}}>
                          <i className="fas fa-clipboard-check"></i>
                        </div>
                        <h4 style={styles.policyTitle}>Check-In Requirements</h4>
                        <ul style={styles.policyList}>
                          <li>Valid government-issued ID</li>
                          <li>Device passcode (if applicable)</li>
                          <li>Description of issue(s)</li>
                          <li>Contact information</li>
                        </ul>
                      </div>
                      <div style={styles.policyCard}>
                        <div style={{...styles.policyIcon, backgroundColor: '#F50963'}}>
                          <i className="fas fa-clock"></i>
                        </div>
                        <h4 style={styles.policyTitle}>Pickup Policy</h4>
                        <ul style={styles.policyList}>
                          <li>Pickup within 30 days of completion</li>
                          <li>Valid ID required for pickup</li>
                          <li>Payment due before release</li>
                          <li>Authorized persons only</li>
                        </ul>
                      </div>
                    </div>

                    <div style={styles.warningBox}>
                      <h4 style={styles.warningTitle}>
                        <i className="fas fa-exclamation-triangle" style={{ marginRight: '10px' }}></i>
                        Abandoned Device Policy
                      </h4>
                      <p style={styles.warningText}>
                        Devices not picked up within <strong>30 days</strong> of repair completion and customer
                        notification will be considered abandoned property. Cell Station reserves the right to
                        dispose of, recycle, or sell abandoned devices to recover repair costs and storage fees.
                        A storage fee of $5 per day may be applied after 14 days. Cell Station is not responsible
                        for any data or personal property on abandoned devices.
                      </p>
                    </div>
                  </div>

                  {/* Section 5 */}
                  <div id="section5" style={styles.section}>
                    <div style={styles.sectionHeader}>
                      <span style={styles.sectionNumber}>5</span>
                      <h3 style={styles.heading}>Pricing & Payment Terms</h3>
                    </div>

                    <h4 style={styles.subheading}>5.1 Pricing</h4>
                    <p style={styles.paragraph}>
                      All prices are quoted in US Dollars and are subject to change without prior notice.
                      Prices quoted are estimates and final pricing may vary based on actual parts required
                      and complexity of repair. Sales tax will be added to all purchases as required by
                      Pennsylvania law.
                    </p>

                    <h4 style={styles.subheading}>5.2 Payment Methods</h4>
                    <p style={styles.paragraph}>
                      We accept the following payment methods:
                    </p>
                    <div style={styles.paymentMethods}>
                      <span style={styles.paymentBadge}><i className="fas fa-money-bill-wave"></i> Cash</span>
                      <span style={styles.paymentBadge}><i className="fab fa-cc-visa"></i> Visa</span>
                      <span style={styles.paymentBadge}><i className="fab fa-cc-mastercard"></i> Mastercard</span>
                      <span style={styles.paymentBadge}><i className="fab fa-cc-amex"></i> American Express</span>
                      <span style={styles.paymentBadge}><i className="fab fa-cc-discover"></i> Discover</span>
                      <span style={styles.paymentBadge}><i className="fas fa-credit-card"></i> Debit Cards</span>
                    </div>

                    <h4 style={styles.subheading}>5.3 Payment Terms</h4>
                    <ul style={styles.list}>
                      <li>Payment is due in full upon completion of repair services</li>
                      <li>Retail purchases require payment at time of sale</li>
                      <li>Devices will not be released until full payment is received</li>
                      <li>A diagnostic fee of $25-$50 may apply if repair is declined after diagnosis</li>
                      <li>Returned checks will incur a $35 processing fee</li>
                    </ul>

                    <h4 style={styles.subheading}>5.4 Deposits</h4>
                    <p style={styles.paragraph}>
                      For repairs requiring special-order parts or extensive labor, a non-refundable deposit
                      of up to 50% may be required before work begins. The deposit will be applied to your
                      final bill. Deposits are non-refundable if you cancel the repair after parts have been
                      ordered.
                    </p>
                  </div>

                  {/* Section 6 */}
                  <div id="section6" style={styles.section}>
                    <div style={styles.sectionHeader}>
                      <span style={styles.sectionNumber}>6</span>
                      <h3 style={styles.heading}>Warranty Terms</h3>
                    </div>

                    <div style={styles.warrantyHighlight}>
                      <div style={styles.warrantyBadge}>
                        <span style={styles.warrantyNumber}>30</span>
                        <span style={styles.warrantyLabel}>DAY WARRANTY</span>
                      </div>
                      <p style={styles.warrantyText}>
                        All repair services performed by Cell Station include a <strong>30-day limited warranty</strong> on
                        parts and labor, effective from the date of repair completion.
                      </p>
                    </div>

                    <h4 style={styles.subheading}>6.1 What's Covered</h4>
                    <ul style={styles.list}>
                      <li>Defective replacement parts installed by Cell Station</li>
                      <li>Workmanship issues directly related to the repair performed</li>
                      <li>Part failures under normal operating conditions</li>
                      <li>Manufacturing defects in replacement components</li>
                    </ul>

                    <h4 style={styles.subheading}>6.2 What's NOT Covered</h4>
                    <ul style={styles.list}>
                      <li>Physical damage occurring after repair (drops, cracks, bends, crushing)</li>
                      <li>Liquid or water damage after repair</li>
                      <li>Damage caused by unauthorized third-party repairs or modifications</li>
                      <li>Software issues, operating system updates, or app-related problems</li>
                      <li>Normal wear and tear</li>
                      <li>Damage resulting from misuse, abuse, or neglect</li>
                      <li>Issues unrelated to the original repair</li>
                      <li>Devices that have been tampered with after repair</li>
                      <li>Cosmetic damage that does not affect functionality</li>
                    </ul>

                    <h4 style={styles.subheading}>6.3 Warranty Claims</h4>
                    <p style={styles.paragraph}>
                      To make a warranty claim, you must present your original receipt and the device to our
                      store within the warranty period. Our technicians will inspect the device to determine
                      if the issue is covered. If covered, repairs will be performed at no additional cost.
                      If not covered, standard repair charges will apply.
                    </p>

                    <h4 style={styles.subheading}>6.4 Accessory Sales</h4>
                    <p style={styles.paragraph}>
                      <strong>All accessory sales are final.</strong> Accessories and retail products do not
                      include warranty coverage. Please inspect all items before leaving the store. See our
                      <Link to="/return-refund-policy" style={styles.inlineLink}> Return & Refund Policy</Link> for
                      more details.
                    </p>
                  </div>

                  {/* Section 7 */}
                  <div id="section7" style={styles.section}>
                    <div style={styles.sectionHeader}>
                      <span style={styles.sectionNumber}>7</span>
                      <h3 style={styles.heading}>Parts & Components</h3>
                    </div>

                    <h4 style={styles.subheading}>7.1 Part Quality</h4>
                    <p style={styles.paragraph}>
                      Cell Station uses high-quality aftermarket parts and, when available, Original Equipment
                      Manufacturer (OEM) parts for repairs. We carefully source our components from reputable
                      suppliers to ensure quality and reliability. All parts meet or exceed industry standards
                      for performance.
                    </p>

                    <h4 style={styles.subheading}>7.2 Manufacturer Warranty Impact</h4>
                    <div style={styles.warningBox}>
                      <p style={styles.warningText}>
                        <strong>Please Note:</strong> Third-party repairs, including those performed by Cell Station,
                        may void any existing manufacturer warranty on your device (e.g., Apple, Samsung, Google).
                        By authorizing repairs, you acknowledge and accept this possibility. We recommend checking
                        your manufacturer warranty status before proceeding with repairs.
                      </p>
                    </div>

                    <h4 style={styles.subheading}>7.3 Software Compatibility</h4>
                    <p style={styles.paragraph}>
                      Cell Station does not guarantee compatibility of replacement parts with future software
                      or operating system updates released by device manufacturers. Some manufacturer updates
                      may affect the functionality of third-party components. This is beyond our control and
                      is not covered under warranty.
                    </p>

                    <h4 style={styles.subheading}>7.4 Original Parts</h4>
                    <p style={styles.paragraph}>
                      Replaced parts become the property of Cell Station unless otherwise agreed upon. If you
                      wish to retain your original parts, please inform our staff before the repair begins.
                    </p>
                  </div>

                  {/* Section 8 */}
                  <div id="section8" style={styles.section}>
                    <div style={styles.sectionHeader}>
                      <span style={styles.sectionNumber}>8</span>
                      <h3 style={styles.heading}>Data & Privacy</h3>
                    </div>

                    <h4 style={styles.subheading}>8.1 Data Loss Disclaimer</h4>
                    <div style={styles.criticalBox}>
                      <i className="fas fa-database" style={styles.criticalIcon}></i>
                      <div>
                        <h4 style={styles.criticalTitle}>IMPORTANT: Back Up Your Data</h4>
                        <p style={styles.criticalText}>
                          Cell Station is <strong>NOT responsible for any data loss</strong> that may occur during
                          the repair process. This includes but is not limited to photos, videos, contacts, messages,
                          apps, documents, and any other stored information. <strong>We strongly recommend creating
                          a complete backup of your device before submitting it for repair.</strong>
                        </p>
                      </div>
                    </div>

                    <h4 style={styles.subheading}>8.2 Device Access</h4>
                    <p style={styles.paragraph}>
                      To properly diagnose and repair your device, our technicians may need to access your device.
                      We respect your privacy and will only access what is necessary for the repair. We do not:
                    </p>
                    <ul style={styles.list}>
                      <li>Copy, transfer, or store your personal data</li>
                      <li>Access personal files, photos, or messages unless required for data recovery services</li>
                      <li>Share any device information with third parties</li>
                      <li>Retain any personal information beyond what is needed for service records</li>
                    </ul>

                    <h4 style={styles.subheading}>8.3 Privacy Policy</h4>
                    <p style={styles.paragraph}>
                      For complete information about how we collect, use, and protect your personal information,
                      please review our <Link to="/privacy-policy" style={styles.inlineLink}>Privacy Policy</Link>.
                    </p>
                  </div>

                  {/* Section 9 */}
                  <div id="section9" style={styles.section}>
                    <div style={styles.sectionHeader}>
                      <span style={styles.sectionNumber}>9</span>
                      <h3 style={styles.heading}>Limitation of Liability</h3>
                    </div>

                    <h4 style={styles.subheading}>9.1 Maximum Liability</h4>
                    <p style={styles.paragraph}>
                      Cell Station's total liability for any claim arising from our services or products shall
                      not exceed the amount paid by you for the specific service or product giving rise to the
                      claim. This limitation applies regardless of the nature of the claim, whether based on
                      contract, tort, negligence, strict liability, or any other legal theory.
                    </p>

                    <h4 style={styles.subheading}>9.2 Exclusion of Damages</h4>
                    <p style={styles.paragraph}>
                      In no event shall Cell Station be liable for any:
                    </p>
                    <ul style={styles.list}>
                      <li>Indirect, incidental, special, or consequential damages</li>
                      <li>Loss of data, files, or information</li>
                      <li>Loss of revenue, profits, or business opportunities</li>
                      <li>Loss of use of device or equipment</li>
                      <li>Cost of substitute equipment or services</li>
                      <li>Personal injury or property damage not directly caused by our negligence</li>
                      <li>Damages arising from circumstances beyond our reasonable control</li>
                    </ul>

                    <h4 style={styles.subheading}>9.3 Assumption of Risk</h4>
                    <p style={styles.paragraph}>
                      By submitting your device for repair, you acknowledge the inherent risks involved in
                      electronic repair services, including but not limited to potential data loss, component
                      failure, and cosmetic changes. You agree to assume these risks and release Cell Station
                      from any claims related to known repair risks that were disclosed to you.
                    </p>
                  </div>

                  {/* Section 10 */}
                  <div id="section10" style={styles.section}>
                    <div style={styles.sectionHeader}>
                      <span style={styles.sectionNumber}>10</span>
                      <h3 style={styles.heading}>Retail Sales Terms</h3>
                    </div>

                    <h4 style={styles.subheading}>10.1 Product Sales</h4>
                    <p style={styles.paragraph}>
                      All retail products are sold "as is" unless otherwise specified. Product images and
                      descriptions are for illustration purposes and may vary slightly from actual products.
                      We make reasonable efforts to accurately display product colors and features, but we
                      cannot guarantee your monitor's display will be accurate.
                    </p>

                    <h4 style={styles.subheading}>10.2 Returns & Exchanges</h4>
                    <p style={styles.paragraph}>
                      Please refer to our <Link to="/return-refund-policy" style={styles.inlineLink}>Return & Refund Policy</Link> for
                      detailed information on returns, exchanges, and refunds for retail purchases.
                    </p>

                    <h4 style={styles.subheading}>10.3 Product Availability</h4>
                    <p style={styles.paragraph}>
                      All products are subject to availability. We reserve the right to limit quantities,
                      discontinue products, and refuse or cancel orders at our discretion. In the event of
                      product unavailability after payment, we will offer a full refund or comparable substitute.
                    </p>
                  </div>

                  {/* Section 11 */}
                  <div id="section11" style={styles.section}>
                    <div style={styles.sectionHeader}>
                      <span style={styles.sectionNumber}>11</span>
                      <h3 style={styles.heading}>Customer Conduct</h3>
                    </div>

                    <p style={styles.paragraph}>
                      We strive to provide excellent service in a safe and respectful environment. We reserve
                      the right to refuse service to anyone who:
                    </p>
                    <ul style={styles.list}>
                      <li>Engages in abusive, threatening, or harassing behavior toward staff or customers</li>
                      <li>Attempts to use fraudulent payment methods or stolen devices</li>
                      <li>Provides false information or misrepresents device ownership</li>
                      <li>Interferes with our ability to serve other customers</li>
                      <li>Violates any applicable laws or regulations</li>
                      <li>Attempts to circumvent our policies or procedures</li>
                    </ul>
                  </div>

                  {/* Section 12 */}
                  <div id="section12" style={styles.section}>
                    <div style={styles.sectionHeader}>
                      <span style={styles.sectionNumber}>12</span>
                      <h3 style={styles.heading}>Dispute Resolution</h3>
                    </div>

                    <h4 style={styles.subheading}>12.1 Informal Resolution</h4>
                    <p style={styles.paragraph}>
                      We encourage customers to contact us directly with any concerns or disputes. Many issues
                      can be resolved quickly through direct communication with our management team. Please
                      contact us at <a href="mailto:icellstation1@gmail.com" style={styles.inlineLink}>icellstation1@gmail.com</a> or
                      call <a href="tel:+12159393933" style={styles.inlineLink}>+1 (215) 939-3933</a>.
                    </p>

                    <h4 style={styles.subheading}>12.2 Governing Law</h4>
                    <p style={styles.paragraph}>
                      These Terms and Conditions shall be governed by and construed in accordance with the
                      laws of the Commonwealth of Pennsylvania, without regard to its conflict of law provisions.
                      You agree to submit to the exclusive jurisdiction of the state and federal courts located
                      in Montgomery County, Pennsylvania for any disputes arising from these Terms or our services.
                    </p>

                    <h4 style={styles.subheading}>12.3 Limitation Period</h4>
                    <p style={styles.paragraph}>
                      Any claim or cause of action arising from or related to these Terms or our services must
                      be filed within one (1) year after the claim arose, or the claim shall be permanently barred.
                    </p>
                  </div>

                  {/* Section 13 */}
                  <div id="section13" style={styles.section}>
                    <div style={styles.sectionHeader}>
                      <span style={styles.sectionNumber}>13</span>
                      <h3 style={styles.heading}>General Provisions</h3>
                    </div>

                    <h4 style={styles.subheading}>13.1 Entire Agreement</h4>
                    <p style={styles.paragraph}>
                      These Terms, together with our Privacy Policy, Warranty Policy, and Return & Refund Policy,
                      constitute the entire agreement between you and Cell Station regarding the subject matter
                      hereof and supersede all prior or contemporaneous communications and proposals.
                    </p>

                    <h4 style={styles.subheading}>13.2 Severability</h4>
                    <p style={styles.paragraph}>
                      If any provision of these Terms is found to be invalid, illegal, or unenforceable, the
                      remaining provisions shall continue in full force and effect. The invalid provision shall
                      be modified to the minimum extent necessary to make it valid and enforceable.
                    </p>

                    <h4 style={styles.subheading}>13.3 Waiver</h4>
                    <p style={styles.paragraph}>
                      Our failure to enforce any provision of these Terms shall not constitute a waiver of that
                      provision or our right to enforce it at a later time.
                    </p>

                    <h4 style={styles.subheading}>13.4 Assignment</h4>
                    <p style={styles.paragraph}>
                      You may not assign or transfer any rights or obligations under these Terms without our
                      prior written consent. We may assign our rights and obligations without restriction.
                    </p>

                    <h4 style={styles.subheading}>13.5 Modifications</h4>
                    <p style={styles.paragraph}>
                      Cell Station reserves the right to modify these Terms at any time. Changes will be
                      effective immediately upon posting on our website or in-store. Your continued use of
                      our services after modifications constitutes acceptance of the updated Terms. We encourage
                      you to review these Terms periodically.
                    </p>

                    <h4 style={styles.subheading}>13.6 Force Majeure</h4>
                    <p style={styles.paragraph}>
                      Cell Station shall not be liable for any failure or delay in performance due to circumstances
                      beyond our reasonable control, including but not limited to natural disasters, pandemics,
                      government actions, supply chain disruptions, or utility failures.
                    </p>
                  </div>

                  {/* Section 14 */}
                  <div id="section14" style={styles.section}>
                    <div style={styles.sectionHeader}>
                      <span style={styles.sectionNumber}>14</span>
                      <h3 style={styles.heading}>Contact Information</h3>
                    </div>

                    <p style={styles.paragraph}>
                      If you have any questions, concerns, or requests regarding these Terms and Conditions,
                      please contact us:
                    </p>

                    <div style={styles.contactBox}>
                      <div style={styles.contactGrid}>
                        <div style={styles.contactItem}>
                          <div style={styles.contactIconWrapper}>
                            <i className="fas fa-store"></i>
                          </div>
                          <div>
                            <h4 style={styles.contactLabel}>Business Name</h4>
                            <p style={styles.contactValue}>Cell Station</p>
                          </div>
                        </div>
                        <div style={styles.contactItem}>
                          <div style={styles.contactIconWrapper}>
                            <i className="fas fa-map-marker-alt"></i>
                          </div>
                          <div>
                            <h4 style={styles.contactLabel}>Address</h4>
                            <p style={styles.contactValue}>
                              2500 W Moreland Rd, Space #1077<br />
                              Willow Grove, PA 19090
                            </p>
                          </div>
                        </div>
                        <div style={styles.contactItem}>
                          <div style={styles.contactIconWrapper}>
                            <i className="fas fa-phone"></i>
                          </div>
                          <div>
                            <h4 style={styles.contactLabel}>Phone</h4>
                            <p style={styles.contactValue}>
                              <a href="tel:+12159393933" style={styles.contactLink}>+1 (215) 939-3933</a>
                            </p>
                          </div>
                        </div>
                        <div style={styles.contactItem}>
                          <div style={styles.contactIconWrapper}>
                            <i className="fas fa-envelope"></i>
                          </div>
                          <div>
                            <h4 style={styles.contactLabel}>Email</h4>
                            <p style={styles.contactValue}>
                              <a href="mailto:icellstation1@gmail.com" style={styles.contactLink}>icellstation1@gmail.com</a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Acceptance Footer */}
                  <div style={styles.acceptanceFooter}>
                    <i className="fas fa-check-circle" style={styles.acceptanceIcon}></i>
                    <p style={styles.acceptanceText}>
                      By using Cell Station's services or making purchases, you acknowledge that you have read,
                      understood, and agree to be bound by these Terms and Conditions.
                    </p>
                  </div>

                  {/* Related Policies */}
                  <div style={styles.relatedPolicies}>
                    <h4 style={styles.relatedTitle}>Related Policies</h4>
                    <div style={styles.relatedLinks}>
                      <Link to="/privacy-policy" style={styles.relatedLink}>
                        <i className="fas fa-user-shield"></i> Privacy Policy
                      </Link>
                      <Link to="/warranty-policy" style={styles.relatedLink}>
                        <i className="fas fa-shield-alt"></i> Warranty Policy
                      </Link>
                      <Link to="/return-refund-policy" style={styles.relatedLink}>
                        <i className="fas fa-undo"></i> Return & Refund Policy
                      </Link>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>
    </PageLayout>
  );
};

const styles = {
  content: {
    backgroundColor: '#fff',
    padding: '50px',
    borderRadius: '16px',
    boxShadow: '0 10px 40px rgba(0,0,0,0.08)',
    marginBottom: '40px',
  },
  headerSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '25px',
    marginBottom: '30px',
    paddingBottom: '30px',
    borderBottom: '2px solid #f0f0f0',
  },
  headerIcon: {
    width: '80px',
    height: '80px',
    borderRadius: '20px',
    background: 'linear-gradient(135deg, #F50963 0%, #ff6b9d 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '36px',
    color: '#fff',
    flexShrink: 0,
  },
  headerTitle: {
    color: '#1a1a2e',
    fontSize: '32px',
    fontWeight: '700',
    margin: '0 0 8px 0',
  },
  headerSubtitle: {
    color: '#666',
    fontSize: '16px',
    margin: 0,
  },
  metaInfo: {
    display: 'flex',
    gap: '30px',
    marginBottom: '30px',
    flexWrap: 'wrap',
  },
  metaItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    color: '#555',
    fontSize: '14px',
  },
  metaIcon: {
    color: '#F50963',
  },
  introBox: {
    backgroundColor: '#f8f9fa',
    padding: '30px',
    borderRadius: '12px',
    marginBottom: '40px',
    borderLeft: '4px solid #F50963',
  },
  introParagraph: {
    color: '#444',
    lineHeight: '1.9',
    margin: 0,
    fontSize: '15px',
  },
  tocSection: {
    backgroundColor: '#1a1a2e',
    padding: '30px',
    borderRadius: '12px',
    marginBottom: '40px',
  },
  tocTitle: {
    color: '#fff',
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '20px',
  },
  tocGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '15px',
  },
  tocColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
  },
  tocLink: {
    color: 'rgba(255,255,255,0.8)',
    textDecoration: 'none',
    fontSize: '14px',
    padding: '8px 15px',
    borderRadius: '6px',
    transition: 'all 0.3s ease',
    backgroundColor: 'rgba(255,255,255,0.05)',
  },
  section: {
    marginBottom: '50px',
    paddingBottom: '30px',
    borderBottom: '1px solid #f0f0f0',
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    marginBottom: '25px',
  },
  sectionNumber: {
    width: '45px',
    height: '45px',
    borderRadius: '12px',
    backgroundColor: '#F50963',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '20px',
    fontWeight: '700',
    flexShrink: 0,
  },
  heading: {
    color: '#1a1a2e',
    fontSize: '24px',
    fontWeight: '700',
    margin: 0,
  },
  subheading: {
    color: '#1a1a2e',
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '12px',
    marginTop: '25px',
  },
  paragraph: {
    color: '#555',
    lineHeight: '1.9',
    marginBottom: '15px',
    fontSize: '15px',
  },
  list: {
    color: '#555',
    lineHeight: '2.2',
    paddingLeft: '25px',
    marginBottom: '20px',
  },
  highlightBox: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '15px',
    backgroundColor: '#fff8e6',
    padding: '20px',
    borderRadius: '10px',
    border: '1px solid #f0e6cc',
    marginTop: '20px',
  },
  highlightIcon: {
    color: '#f0ad4e',
    fontSize: '24px',
    flexShrink: 0,
    marginTop: '2px',
  },
  highlightText: {
    color: '#856404',
    lineHeight: '1.7',
    margin: 0,
    fontSize: '14px',
  },
  servicesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '20px',
    marginTop: '25px',
  },
  serviceCard: {
    backgroundColor: '#f8f9fa',
    padding: '25px',
    borderRadius: '12px',
    border: '1px solid #e9ecef',
  },
  serviceIcon: {
    width: '50px',
    height: '50px',
    borderRadius: '12px',
    backgroundColor: '#F50963',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '22px',
    marginBottom: '15px',
  },
  serviceTitle: {
    color: '#1a1a2e',
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '15px',
  },
  serviceList: {
    color: '#555',
    lineHeight: '2',
    paddingLeft: '18px',
    margin: 0,
    fontSize: '14px',
  },
  policyGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '20px',
    marginBottom: '25px',
  },
  policyCard: {
    backgroundColor: '#f8f9fa',
    padding: '25px',
    borderRadius: '12px',
    textAlign: 'center',
  },
  policyIcon: {
    width: '60px',
    height: '60px',
    borderRadius: '50%',
    backgroundColor: '#F50963',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    margin: '0 auto 15px',
  },
  policyTitle: {
    color: '#1a1a2e',
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '15px',
  },
  policyList: {
    textAlign: 'left',
    color: '#555',
    lineHeight: '2',
    paddingLeft: '20px',
    margin: 0,
    fontSize: '14px',
  },
  warningBox: {
    backgroundColor: '#fff5f5',
    padding: '25px',
    borderRadius: '12px',
    border: '1px solid #f5c6cb',
  },
  warningTitle: {
    color: '#721c24',
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '10px',
  },
  warningText: {
    color: '#721c24',
    lineHeight: '1.8',
    margin: 0,
    fontSize: '14px',
  },
  paymentMethods: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    marginBottom: '25px',
  },
  paymentBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 18px',
    backgroundColor: '#f8f9fa',
    borderRadius: '8px',
    fontSize: '14px',
    color: '#333',
    border: '1px solid #e9ecef',
  },
  warrantyHighlight: {
    display: 'flex',
    alignItems: 'center',
    gap: '25px',
    background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
    padding: '30px',
    borderRadius: '12px',
    marginBottom: '30px',
  },
  warrantyBadge: {
    backgroundColor: '#F50963',
    padding: '20px',
    borderRadius: '12px',
    textAlign: 'center',
    minWidth: '100px',
    flexShrink: 0,
  },
  warrantyNumber: {
    display: 'block',
    color: '#fff',
    fontSize: '36px',
    fontWeight: '700',
    lineHeight: 1,
  },
  warrantyLabel: {
    display: 'block',
    color: 'rgba(255,255,255,0.9)',
    fontSize: '11px',
    fontWeight: '600',
    marginTop: '5px',
    letterSpacing: '1px',
  },
  warrantyText: {
    color: 'rgba(255,255,255,0.9)',
    lineHeight: '1.8',
    margin: 0,
    fontSize: '15px',
  },
  criticalBox: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '20px',
    background: 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
    padding: '25px',
    borderRadius: '12px',
    marginBottom: '25px',
  },
  criticalIcon: {
    color: '#fff',
    fontSize: '32px',
    flexShrink: 0,
  },
  criticalTitle: {
    color: '#fff',
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '10px',
  },
  criticalText: {
    color: 'rgba(255,255,255,0.95)',
    lineHeight: '1.8',
    margin: 0,
    fontSize: '14px',
  },
  inlineLink: {
    color: '#F50963',
    textDecoration: 'none',
    fontWeight: '500',
  },
  contactBox: {
    backgroundColor: '#f8f9fa',
    padding: '30px',
    borderRadius: '12px',
    marginTop: '25px',
  },
  contactGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '25px',
  },
  contactItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '15px',
  },
  contactIconWrapper: {
    width: '45px',
    height: '45px',
    borderRadius: '10px',
    backgroundColor: '#F50963',
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    flexShrink: 0,
  },
  contactLabel: {
    color: '#999',
    fontSize: '12px',
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    marginBottom: '5px',
  },
  contactValue: {
    color: '#333',
    fontSize: '15px',
    lineHeight: '1.6',
    margin: 0,
  },
  contactLink: {
    color: '#F50963',
    textDecoration: 'none',
  },
  acceptanceFooter: {
    display: 'flex',
    alignItems: 'center',
    gap: '20px',
    backgroundColor: '#f0fff4',
    padding: '25px',
    borderRadius: '12px',
    border: '1px solid #c3e6cb',
    marginTop: '40px',
  },
  acceptanceIcon: {
    color: '#28a745',
    fontSize: '36px',
    flexShrink: 0,
  },
  acceptanceText: {
    color: '#155724',
    lineHeight: '1.7',
    margin: 0,
    fontSize: '14px',
  },
  relatedPolicies: {
    marginTop: '40px',
    textAlign: 'center',
  },
  relatedTitle: {
    color: '#1a1a2e',
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '20px',
  },
  relatedLinks: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    flexWrap: 'wrap',
  },
  relatedLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 24px',
    backgroundColor: '#f8f9fa',
    color: '#333',
    textDecoration: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '500',
    border: '1px solid #e9ecef',
    transition: 'all 0.3s ease',
  },
};

export default TermsConditions;
